import { render, staticRenderFns } from "./MdPeriodicPerformance.vue?vue&type=template&id=2484aa6a&"
import script from "./MdPeriodicPerformance.vue?vue&type=script&lang=js&"
export * from "./MdPeriodicPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports